declare function TriggerEventOnCamparePlans(zip_code,tdu,flow_type): void;
import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { ResidentialService } from '../residential.service';
import * as _ from 'underscore';
import { RecommendationService } from '../recommendation/recommendation.service';
import { UserSettingsService } from 'src/app/user-settings/user-settings.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PlatformLocation } from '@angular/common';
@Component({
  selector: 'app-pre-success',
  templateUrl: './pre-success.component.html',
  styleUrls: ['./pre-success.component.css'],
})
export class PreSuccessComponent implements OnInit {
  redirect;
  apiTimer;
  modalVisible = false;
  showText = true;
  questionNotifyObj;
  deviceWidth;
  queryObj = {
    _id: '',
    esiid: '',
    hg_orders_id: '',
    hg_accountId: '',
  };
  entered = false;
  updateObj = {
    processCompleted: '',
    showNotification: '',
    type: '',
  };
  url = environment.api_url;

  private imagesList: string[] = [];
  public currentImage: string = '';
  private currentIndex: number = 0;
  private intervalId: any;

  constructor(
    private router: Router,
    private residentialService: ResidentialService,
    private http: HttpClient,
    private recommendationService: RecommendationService,
    private cd: ChangeDetectorRef,
    private userSettingsService: UserSettingsService,
    private location_: PlatformLocation
  ) {
    this.entered = true;
    this.location_.onPopState(() => {
      //history.back();
    
        // setTimeout(function(){  

        //   this.router.navigate([
        //     'user-settings',
        //     '63669df9a3226c1284e2070b',
        //   ]);

        // },100)
     
       
        // this.router.navigate([
        //   'user-settings',
        //  '63669df9a3226c1284e2070b',
        // ]);
      
     
  });


  }

  @HostListener('window:beforeunload', ['$event'])
 
  beforeunloadHandler($event) {
    $event.returnValue = false;
    const questionObj = {
      questionStatus: 'Completed',
      questionStep: this.residentialService.currentId,
      type: this.residentialService.service,
      percentage: 100,
      enrollmentState: 'Quitted',
    };
    sessionStorage.setItem('questionStatusObj', JSON.stringify(questionObj));
    setTimeout(() => {
      return this.residentialService.quitFlow();
    }, 50);
  }

  startImageRotation(): void {
    // Set the initial image
    this.currentImage = this.imagesList[this.currentIndex];

    // Start rotating images every 2 seconds
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.imagesList.length;
      this.currentImage = this.imagesList[this.currentIndex];
    }, 500);
  }

  ngOnDestroy(): void {
    // Clear the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
   ngOnInit() {
    this.deviceWidth = window.innerWidth;
    var utilitycode = sessionStorage.getItem('utilitycode');
    var zipcode = sessionStorage.getItem('zipcode');
    if(utilitycode != null)
    {
      const user = {
        "Utility": utilitycode
     
      };
      this.http.post<string[]>(this.url + '/getREPImagesByUtility', user)
                  .subscribe((imageslist) => {
                

                if (imageslist && imageslist.length > 0) {
                  this.imagesList = imageslist;
                  this.startImageRotation(); // Start rotating images once fetched
                } else {
                  console.error('No images received from the server.');
                }

       });
      this.showText = false;
    }

    // history.pushState(null, '');
    // history.pushState(null, null, 'user-settings/63669df9a3226c1284e2070b');
    var a = history.state;
     
    const queryString = window.location.search;
    //console.log(queryString);
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get('id')

    if(id == "0")
    {
      window.location.href = environment.aap_url;
    }
    const user = sessionStorage.getItem('userObj');
    if (user) {


      let questionnarieObj = sessionStorage.getItem('userResponse');
      let percentage = sessionStorage.getItem('percentage');
      sessionStorage.setItem('percentage',JSON.stringify(100));
      if (questionnarieObj && user) {
        const body = new HttpParams()
          .append('questionnarieObj', questionnarieObj)
          .append('userObj', user)
          .append('percentage', '100');
        this.http
          .post(this.url + '/saveQuestions', body)
          .subscribe((res: any) => {});
      }
    }
    if (!_.isEmpty(this.residentialService.user)) {

      // const questionID31 = {
      //   res_question_id: '0032',
      //   fieldName: 'avg_price_kwh',
      //   fieldValue: '0.0',
      // };
      // this.residentialService.updateResponses(questionID31);


        var utilitycode = sessionStorage.getItem('utilitycode');
        var zipcode = sessionStorage.getItem('zipcode');
        if(utilitycode == null)
        {

          this.residentialService.saveuserResponses().subscribe((response) => {
            const result = response;
            if (result['statusCode'] === '002') {
            } else {
              this.questionNotifyObj =
                this.userSettingsService.questionNotificationObj;
              if (
                this.questionNotifyObj &&
                this.questionNotifyObj.type === 'questionnarie_not_completed'
              ) {
                this.queryObj._id = this.questionNotifyObj._id;
                this.queryObj.esiid = this.questionNotifyObj.esiid;
                this.queryObj.hg_accountId = this.questionNotifyObj.hg_accountId;
                this.queryObj.hg_orders_id = this.questionNotifyObj.hg_orders_id;
                this.updateObj.processCompleted = 'true';
                this.updateObj.type = 'enrollment_not_completed';
                if (this.questionNotifyObj.showNotification === true) {
                  this.updateObj.showNotification = 'false';
                }
                const questionbody = new HttpParams()
                  .append('queryObj', JSON.stringify(this.queryObj))
                  .append('updateObj', JSON.stringify(this.updateObj));
                this.http
                  .post(this.url + '/updateNotification', questionbody)
                  .subscribe((notifyres) => {
                    const notifyresult = notifyres;
                  });
              }
              this.residentialService.setUser({
                userName: result['data'].userName,
                accountId: result['data'].hg_accountId,
              });
              this.recommendationService.userName = result['data'].userName;
              this.recommendationService.hg_accountId = result['data'].hg_accountId;
              this.recommendationService.recommendationObj =
                result['recommendedProduct'];
              sessionStorage.setItem(
                'recommendedProducts',
                JSON.stringify(result['recommendedProduct'])
              );
              if (this.residentialService.service !== 'Switching Providers') {
                this.updateNotification(this.residentialService.user.accountId);
                sessionStorage.setItem(
                  'QuestionUserID',
                  this.residentialService.user.accountId
                );
                  this.redirect = setTimeout(() => {
                    this.router.navigate([
                      '/recommendation/compare-product',
                      this.residentialService.user.accountId,
                    ]);
                  }, 5000);
    
                
              } else {
                const discount =
                  this.recommendationService.recommendationObj
                    .res_products_recommendations[0].new_tier.discount_percent;
                if (Number(discount) > 0) {
                  this.redirect = setTimeout(() => {
                    this.router.navigate([
                      '/recommendation',
                      this.residentialService.user.accountId,
                    ]);
                    sessionStorage.removeItem('recommendedProduct');
                  }, 5000);
                } else {
                  this.updateNotification( this.residentialService.user.accountId);
                  sessionStorage.setItem(
                    'QuestionUserID',
                    this.residentialService.user.accountId
                  );
                  this.redirect = setTimeout(() => {
                    this.router.navigate([
                      '/recommendation/compare-product',
                      this.residentialService.user.accountId,
                    ]);
                  }, 5000);
                }
              }
            }
          });
        }
        else
        {

          if (this.deviceWidth < 768) {

            // $(".Headermargin2").addClass("h-0");
            $(".Headermargin2").removeClass("Headermargin2");
  
           }
          sessionStorage.removeItem(
            'QuestionUserID'
          );
          const user = {
            "utilityName": utilitycode,
            "sqFt":"btw_1250_2250",
            "dwellingtype":"Apartment",
            "zipcode":zipcode
          };
          sessionStorage.setItem(
            'widthoutQuestionUserRequest',
            JSON.stringify(user));
           TriggerEventOnCamparePlans(zipcode,utilitycode,"residential");
          this.residentialService.widthoutQuestionUserRequest = user;
          this.residentialService.getRecommendationsByUtility(user).subscribe((res: any) => {
            const result = res;        
            if (result['statusCode'] === '002') {
            } else {
              // this.residentialService.setUser({
              //   userName: result['data'].userName,
              //   accountId: result['data'].hg_accountId,
              // });
              // this.recommendationService.userName = result['data'].userName;
          
  
  
             this.residentialService.user = JSON.parse(
              sessionStorage.getItem('userObj')
            );
  
            this.recommendationService.recommendationObj =
            result['recommendedProduct'];
          sessionStorage.setItem(
            'recommendedProducts',
            JSON.stringify(result['recommendedProduct'])
          );
            if(this.residentialService.user  != null)
            {
              this.recommendationService.hg_accountId =  this.residentialService.user._id;//result['data'].hg_accountId;
              //if (this.residentialService.service !== 'Switching Providers') {
                this.updateNotification( this.residentialService.user._id,user);

                var timeout = 5000;
                if(!this.showText){
                  timeout = 0;
                }


                this.redirect = setTimeout(() => {
                  this.router.navigate([
                    '/recommendation/compare-product',
                    this.residentialService.user._id,
                  ]);
                }, timeout);
            //  } 
            }else
            {
              
              this.recommendationService.hg_accountId = 90987;//result['data'].hg_accountId;
              //if (this.residentialService.service !== 'Switching Providers') {
                this.redirect = setTimeout(() => {
                  this.router.navigate([
                    '/recommendation/compare-product',
                    90987,
                  ]);
                }, 3000);
              //} 
            }
             
              
          
            }
          });
  

        }

 
    } else {

        var utilitycode = sessionStorage.getItem('utilitycode');
        var zipcode = sessionStorage.getItem('zipcode');
        if(utilitycode == null)
        {

            let questionObj;
            if (!_.isEmpty(this.residentialService.questionnaireStatusObj)) {
              questionObj = this.residentialService.questionnaireStatusObj;
            } else {
              questionObj =
                sessionStorage.getItem('questionStatusObj') !== undefined
                  ? JSON.parse(sessionStorage.getItem('questionStatusObj'))
                  : null;
            }
            const questionID31 = {
              res_question_id: '0032',
              fieldName: 'avg_price_kwh',
              fieldValue: '0.0',
            };
            this.residentialService.updateResponses(questionID31);
            let questionnarieObj;
            if (!_.isEmpty(this.residentialService.userResponse.userResponses)) {
              questionnarieObj = this.residentialService.userResponse;
            } else {
              questionnarieObj = JSON.parse(sessionStorage.getItem('userResponse'));
            }
            const user = {
              esiid: null,
              questionStatusObj: questionObj,
              questionnarieObj: questionnarieObj,
            };
            this.residentialService.getRecommendations(user).subscribe((res: any) => {
              const result = res;
              if (result['statusCode'] === '002') {
              } else {
                this.residentialService.setUser({
                  userName: result['data'].userName,
                  accountId: result['data'].hg_accountId,
                });
                this.recommendationService.userName = result['data'].userName;
                this.recommendationService.hg_accountId = result['data'].hg_accountId;
                this.recommendationService.recommendationObj =
                  result['recommendedProduct'];
                sessionStorage.setItem(
                  'recommendedProducts',
                  JSON.stringify(result['recommendedProduct'])
                );
                if (this.residentialService.service !== 'Switching Providers') {
                  this.updateNotification(this.residentialService.user.accountId);
                  sessionStorage.setItem(
                    'QuestionUserID',
                    this.residentialService.user.accountId
                  );
                  this.redirect = setTimeout(() => {
                    this.router.navigate([
                      '/recommendation/compare-product',
                      this.residentialService.user.accountId,
                    ]);
                  }, 5000);
                } else {
                  const discount =
                    this.recommendationService.recommendationObj
                      .res_products_recommendations[0].new_tier.discount_percent;
                  if (Number(discount) > 0) {
                    this.redirect = setTimeout(() => {
                      this.router.navigate([
                        '/recommendation',
                        this.residentialService.user.accountId,
                      ]);
                      sessionStorage.removeItem('recommendedProduct');
                    }, 5000);
                  } else {
                    this.updateNotification(this.residentialService.user.accountId);
                    this.redirect = setTimeout(() => {
                      sessionStorage.setItem(
                        'QuestionUserID',
                        this.residentialService.user.accountId
                      );
                      this.router.navigate([
                        '/recommendation/compare-product',
                        this.residentialService.user.accountId,
                      ]);
                    }, 5000);
                  }
                }
              }
            });
      }
      else
      {

        if (this.deviceWidth < 768) {

          // $(".Headermargin2").addClass("h-0");
          $(".Headermargin2").removeClass("Headermargin2");

         }
        sessionStorage.removeItem(
          'QuestionUserID'
        );
        const user = {
          "utilityName": utilitycode,
          "sqFt":"btw_1250_2250",
          "dwellingtype":"Apartment",
          "zipcode":zipcode
        };
        sessionStorage.setItem(
          'widthoutQuestionUserRequest',
          JSON.stringify(user));
        TriggerEventOnCamparePlans(zipcode,utilitycode,"residential");
        this.residentialService.widthoutQuestionUserRequest = user;
        this.residentialService.getRecommendationsByUtility(user).subscribe((res: any) => {
          const result = res;
          if (result['statusCode'] === '002') {
          } else {
            // this.residentialService.setUser({
            //   userName: result['data'].userName,
            //   accountId: result['data'].hg_accountId,
            // });
            // this.recommendationService.userName = result['data'].userName;
        


           this.residentialService.user = JSON.parse(
            sessionStorage.getItem('userObj')
          );

          this.recommendationService.recommendationObj =
          result['recommendedProduct'];
        sessionStorage.setItem(
          'recommendedProducts',
          JSON.stringify(result['recommendedProduct'])
        );
          if(this.residentialService.user  != null)
          {
            
            this.recommendationService.hg_accountId =  this.residentialService.user._id;//result['data'].hg_accountId;
            //if (this.residentialService.service !== 'Switching Providers') {
              this.updateNotification( this.residentialService.user._id,user);
                var timeout = 5000;
                if(!this.showText){
                  timeout = 0;
                }

              this.redirect = setTimeout(() => {
                this.router.navigate([
                  '/recommendation/compare-product',
                  this.residentialService.user._id,
                ]);
              }, timeout);
           // } 
          }else
          {
            
            this.recommendationService.hg_accountId = 90987;//result['data'].hg_accountId;
            //if (this.residentialService.service !== 'Switching Providers') {
              this.redirect = setTimeout(() => {
                 this.router.navigate([
                   '/recommendation/compare-product',
                   90987,
                 ]);
              }, 3000);
            } 
          //}
           
            
        
          }
        });

      }
    }
     

  
    sessionStorage.removeItem('selectedEnergyProvider');
   }

  updateNotification(id,user_object = null)
  {

    var msg = 'Click the button below to see what energy plans Honest Gorilla is recommending for you. See much you could be saving on energy.';

    if(this.residentialService.userResponse != null)
    {

      const itemValue = _.findWhere(this.residentialService.userResponse.userResponses, {
        res_question_id: '008',
      });
      var formatted_address__  ="";
      if(itemValue != null && itemValue.fieldValue.formatedAddress != null)
      {
        var a = this.getFormattedAddressByState(itemValue.fieldValue.formatedAddress,itemValue.fieldValue.formatedAddress.apartment);
        if(itemValue.fieldValue.formatedAddress != undefined && itemValue.fieldValue.formatedAddress != null && a != '') {
  
          var formatted_address = itemValue.fieldValue.formatedAddress.replace(", USA","");
          var unit = (a['apartment'] != "" && a['apartment'] != undefined ?  a['apartment'] + ", " : "") ;
          formatted_address__ = a['street_address'] + ", " + unit + a['city'] + ", " +  a['state'] + ", " + a['zipcode'];
          msg = "Click the button below to see what energy plans Honest Gorilla is recommending for you at "+formatted_address__+". See much you could be saving on energy."
      
        }
       
        //msg = "Your energy usage profile for "+address+" is complete by no product has been selected. What are you waiting for?"
  
      }
      //var formatted_address = this.residentialService.formatedAddress.replace(", USA","");
      //msg = "Complete your profile regarding "+formatted_address+" to see what energy plans Honest Gorilla is recommending for you."
  
    }


    let notificationObj = {
      type: 'enrollment_not_completed',
      hg_orders_id: '',
      hg_accountId:id,
        
      esiid: '',
      showNotification: true,
      isRead: false,
      navigation_link: null,
      buttonName: 'FINISH SHOPPING',
      buttonUrl: '/residentialQues',
      order_no: '',
      userAddress: formatted_address__,
      questionnairePercent: 100,
      percentage: 100,
      title: "You're Almost Done",
      message:msg,
      createdBy: 0,
      lastUpdatedBy: 0,
      createdDate: this.residentialService.getServiceTypeDateObj(),
      lastUpdateDate: this.residentialService.getServiceTypeDateObj(),
      processCompleted: false,
      StraigthPlanUserRequest : user_object
    };
    this.residentialService.notificationObj = notificationObj;
    this.residentialService.updateNotificationObject(notificationObj);

   
  }

  getFormattedAddressByState(address,apt) {
    let temp_address = {};
    try{
     
      let address_ = address;
      if (address_ != "" && address_ != "undefined") {
        let address = address_.split(',');
        let [state, zipcode] = address[2] ? address[2].trim().split(' ') : '';
        if (address[0].toUpperCase().indexOf('APT') > 1) {
          temp_address['street_address'] = address[0].substring(
            0,
            address[0].toUpperCase().indexOf('APT') - 1
          );
          temp_address['apartment'] = address[0].substring(address[0].toUpperCase().indexOf('APT') + 4);
        } else {
          temp_address['street_address'] = address[0];
          temp_address['apartment'] = apt;
        }
        temp_address['city'] = address[1] ? address[1].trim() : '';
        temp_address['state'] = state ? state : '';
        temp_address['zipcode'] = zipcode ? zipcode : '';
      }
      return temp_address;

    }catch{
    
     
      return '';


    }
  
  }
}
